import React, { useRef, useState } from 'react';
import { Leaf, Heart, Shield } from 'lucide-react';

export default function WovenShades() {
   const [activeIndex, setActiveIndex] = useState(null);
  
    const toggleFAQ = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
  const whatWeOfferRef = useRef(null); // Reference for the "What We Offer" section
      
        const scrollToSection = () => {
          if (whatWeOfferRef.current) {
            whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
          }
        };
  const gallery = [
    "images/woven.jpg",
    "images/woven5.jpg",
    "images/woven4.jpg",
  ];

  const features = [
    {
      title: "Natural Light Filtering",
      description:
        "Softly diffuses sunlight, creating a warm and inviting ambiance while reducing glare.",
    },
    {
      title: "Organic Aesthetic",
      description:
        "Handcrafted from natural materials like bamboo, jute, and grasses for a timeless, earthy look.",
    },
    {
      title: "Durable & Sustainable",
      description:
        "Eco-friendly and built to last, offering both beauty and long-term functionality.",
    },
    {
      title: "UV Protection",
      description:
        "Blocks harmful UV rays to protect furniture and flooring while allowing soft light to enter.",
    },
    {
      title: "Energy Efficiency",
      description:
        "Provides natural insulation, keeping rooms cooler in summer and warmer in winter.",
    },
    {
      title: "Custom Fit & Versatility",
      description:
        "Available in various weaves, colors, and sizes to complement any decor and window type.",
    },
  ];
  return (
    <div className="bg-stone-50">
      {/* Hero Section */}
      {/* <section
        className="text-center object-cover h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('images/woven3.webp')" }}
      >
  <div className="px-8 sm:px-16 lg:px-28">
          <h1 className="text-4xl text-center text-[#fff] font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pt-32 ">
          Natural
          
          </h1>

          <h1 className="text-4xl text-center font-Montserrat uppercase font-semibold mb-4 xl:text-9xl  text-[#fff]">
         Woven Shades
          </h1>
        </div>

        <div className=" mt-8 sm:mt-16 lg:mt-10 flex justify-center ">
          <button onClick={scrollToSection} className="text-white bg-[#000] text-xl w-60 px-6 py-3 ">
            LEARN MORE
          </button>
        </div>
      </section> */}

<section
  className="object-cover h-screen bg-cover bg-center flex flex-col justify-center items-center lg:items-start lg:text-left"
  style={{ backgroundImage: "url('images/woven3.webp')" }}
>
  <div className="px-8 sm:px-16 lg:px-24 text-center lg:text-left">
    <h1 className="text-5xl md:text-8xl xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
    Natural
    </h1>
    <h1 className="text-5xl md:text-8xl xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
    Woven Shades
    </h1>
{/* Button positioned below the text */}
<div className="mt-4 lg:mt-10 flex justify-center lg:justify-start">
    <button
      onClick={scrollToSection}
      className="text-black bg-white text-xl md:w-52 px-6 py-2"
    >
      LEARN MORE
    </button>
  </div>
  </div>
</section>

      {/* Features */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              {
                icon: <Leaf className="w-8 h-8" />,
                title: "Eco-Friendly",
                description: "Sustainable materials and responsible manufacturing"
              },
              {
                icon: <Heart className="w-8 h-8" />,
                title: "Artisan Crafted",
                description: "Each shade is uniquely handwoven by skilled artisans"
              },
              {
                icon: <Shield className="w-8 h-8" />,
                title: "UV Protection",
                description: "Natural protection while maintaining organic aesthetics"
              }
            ].map((feature, index) => (
              <div key={index} className="bg-white p-8 rounded-2xl shadow-sm">
                <div className="inline-block p-3 bg-stone-100 rounded-xl mb-6">
                  <div className="text-stone-700">{feature.icon}</div>
                </div>
                <h1 className="text-2xl font-bold mb-4">{feature.title}</h1>
                <h2 className="text-stone-600">{feature.description}</h2>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Materials Showcase */}
      <section ref={whatWeOfferRef} className="py-20 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16">Natural Materials</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { name: "Bamboo", description: "Sustainable and durable" },
              { name: "Reed", description: "Classic natural texture" },
              { name: "Jute", description: "Organic earthy appeal" }
            ].map((material, index) => (
              <div key={index} className="group relative aspect-square overflow-hidden rounded-2xl">
                <img
                  src={gallery[index]}
                  alt={material.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-white text-2xl font-bold">{material.name}</h3>
                    <p className="text-white/80 mt-2">{material.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Design Process */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-8">Artisan Craftsmanship</h2>
              <div className="space-y-6">
                {[
                  {
                    step: "Material Selection",
                    description: "Premium natural materials carefully chosen for quality and sustainability"
                  },
                  {
                    step: "Hand Weaving",
                    description: "Traditional techniques passed down through generations"
                  },
                  {
                    step: "Quality Control",
                    description: "Rigorous inspection ensuring lasting beauty and functionality"
                  }
                ].map((process, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-8 h-8 bg-stone-200 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="font-bold text-stone-700">{index + 1}</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2">{process.step}</h3>
                      <p className="text-stone-600">{process.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <img
                src={gallery[1]}
                alt="Artisan craftsmanship"
                className="w-full rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
<section className="mb-16  p-8 max-w-6xl mx-auto xl:pt-20 font-playfair">
  <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
    Key Features of Woven Shades
  </h2>
  <div>
    {features.map((feature, index) => (
      <div key={index} className="border-b border-gray-400 p-3 mb-4">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => toggleFAQ(index)}
        >
          <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
            {feature.title}
          </h3>
          <button
            className="text-xl md:text-4xl font-bold text-gray-600"
            aria-label="Toggle FAQ"
          >
            {activeIndex === index ? "-" : "+"}
          </button>
        </div>
        {activeIndex === index && (
          <p className="text-gray-600 mt-2 text-base md:text-2xl">
            {feature.description}
          </p>
        )}
      </div>
    ))}
  </div>
</section>;
    </div>
  );
}